import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client.js';

const KEY = (pid: string) => ['projects', pid, 'retro-items'] as const;

export function useRetroItems(projectId: string | undefined) {
  return useQuery({
    queryKey: KEY(projectId ?? ''),
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/retro-items`),
    enabled: !!projectId,
  });
}

export function useCreateRetroItem(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => apiClient.post(`/api/v1/projects/${pid}/retro-items`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useUpdateRetroItem(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      apiClient.patch(`/api/v1/projects/${pid}/retro-items/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}

export function useDeleteRetroItem(pid: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/api/v1/projects/${pid}/retro-items/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY(pid) }),
  });
}
